export const logoutAndClear = (logoutUser,auth) => {
    localStorage.clear();
    // logoutUser();
    auth.logout(() => {
        window.location.reload();
    });
};